// import { useDroppable } from '@dnd-kit/core';
import { useDroppable } from '@dnd-kit/core';
import React, { CSSProperties, PropsWithChildren } from 'react';

export const StoryDroppable = ({ id, children }: PropsWithChildren<{ id: string }>) => {
    const { isOver, setNodeRef } = useDroppable({
        id: id,
    });
    const style: CSSProperties = {
        opacity: isOver ? 1 : 0.5,
        background: isOver ? '#EAECF0' : 'none',
    };

    return (
        <div ref={setNodeRef} style={style} className="Daily__story-row_dropArea">
            {children}
        </div>
    );
};
